<aside>
  <h2>Athlete library</h2>

  <nav aria-label="Athlete library sections">
    @for (item of navItems; track item.key) {
      <button
        tuiButton
        appearance="flat-grayscale"
        type="button"
        [iconStart]="item.icon"
        [tuiAppearanceState]="activeSection() === item.key ? 'hover' : null"
        (click)="navigateTo(item.key)"
      >
        {{ item.label }}
      </button>
    }
  </nav>
</aside>

<main>
  <header class="page-header" [class.page-header--subpage]="isCreateView() || isEditView()">
    @if (!isCreateView() && !isEditView()) {
      <div class="page-header__copy">
        <h1>{{ headerTitle() }}</h1>
        <p>{{ activeItem().description }}</p>
      </div>

      @if (activeItem().actionLabel) {
        <button
          tuiButton
          type="button"
          size="s"
          [iconStart]="activeItem().key === 'performance-limits' ? '@tui.check' : '@tui.plus'"
          [disabled]="isHeaderActionDisabled()"
          (click)="onHeaderAction()"
        >
          {{ activeItem().actionLabel }}
        </button>
      }
    } @else {
      <h1>{{ headerTitle() }}</h1>
    }
  </header>

  <section class="section-content">
    @switch (activeSection()) {
      @case ('athletes') {
        @defer {
          @if (!isCreateView() && !isEditView()) {
            <app-apc-athlete-list
              [autoSelectFirstAthlete]="false"
              (editRequested)="navigateToEdit($event)"
            ></app-apc-athlete-list>
          } @else {
            @if (isCreateView()) {
              <app-apc-athlete-create-panel
                (cancelled)="navigateToList()"
                (created)="navigateToList()"
              ></app-apc-athlete-create-panel>
            } @else if (editingAthleteId(); as athleteId) {
              <app-apc-athlete-edit-panel
                [athleteId]="athleteId"
                (cancelled)="navigateToList()"
                (saved)="navigateToList()"
              ></app-apc-athlete-edit-panel>
            }
          }
        }
      }
      @case ('groups') {
        @defer {
          @if (!isCreateView()) {
            <app-apc-athlete-group-modal></app-apc-athlete-group-modal>
          } @else {
            <app-apc-athlete-group-create-panel
              (cancelled)="navigateToList()"
              (created)="navigateToList()"
            ></app-apc-athlete-group-create-panel>
          }
        }
      }
      @case ('categories') {
        @defer {
          <app-athlete-category-management
            (viewLimits)="navigateToLimits($event)"
          ></app-athlete-category-management>
        }
      }
      @case ('performance-limits') {
        @defer {
          <app-athlete-category-limits [initialLevelId]="pendingLimitLevelId()" />
        }
      }
    }
  </section>
</main>
